import React from 'react';
import DefaultSearchResults from '../components/PanelsComponents/DefaultPanels/DefaultSearchResults';

//= ========================================================================
const Panel_B02_SendMoneySearchResults = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultSearchResults
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
  />
);

export default Panel_B02_SendMoneySearchResults;
